import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import Profile from "components/params/profile.js";
import styles from "./index.module.css";
import { Dropdown } from "primereact/dropdown";
import i18n from "utils/i18n";
import { useNavigate } from "react-router";
import Cookies from "js-cookie";
import { ToastService, ToastComponent } from "services/toast.service";
import { useTranslation } from "react-i18next";
import { SquareArrowUpRight } from "lucide-react";
import useIsMobile from "hooks/detect-mobile-screen";

const Params = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const languages = [
    { name: "Français", code: "fr" },
    { name: "English", code: "en" },
  ];

  const initialLanguage = (() => {
    const savedLanguage = localStorage.getItem("i18nextLng") || "fr";
    return (
      languages.find((lang) => lang.code === savedLanguage) || languages[0]
    );
  })();

  const [language, setLanguage] = useState(initialLanguage);

  const changeLanguage = (language) => {
    i18n.changeLanguage(language.code);
    localStorage.setItem("i18nextLng", language.code);
    ToastService.showSuccessToast(t("parameters.language.success"));
    setLanguage(language);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    Cookies.remove("token");
    navigate("/login");
  };

  const tabHeaderTemplate = (options) => {
    const className = options.selected ? "custom-active-tab" : "custom-tab";
    return (
      <div
        className={styles[className]}
        onClick={() => setActiveIndex(options.index)}
      >
        <span>{options.titleElement}</span>
      </div>
    );
  };

  return (
    <div className="dashboard-container">
      <ToastComponent />
      <div className={`${styles["header-wrapper"]} mb-32`}>
        <div className={styles.header}>
          <h1 className="title-1">{t("parameters.title")}</h1>
          <button className="btn btn--secondary" onClick={handleLogout}>
            {t("actions.logout")}
          </button>
        </div>
        {isMobile && (
          <div className={styles.report} onClick={() => navigate("/reports")}>
            <SquareArrowUpRight className="icon icon-information" size={16} />
            <p className="subtitle-2-variant">{t("navigation.item.reports")}</p>
          </div>
        )}
      </div>
      <section className={styles.wrapper}>
        <TabView
          className={styles.tab}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel
            header={t("parameters.profile.title")}
            headerTemplate={tabHeaderTemplate}
          >
            <Profile />
          </TabPanel>
          <TabPanel
            header={t("parameters.language.title")}
            headerTemplate={tabHeaderTemplate}
          >
            <p className="title-3-variant mb-32">
              {t("parameters.language.description")}
            </p>
            <div className="form-group">
              <label htmlFor="end">{t("parameters.language.title")}</label>
              <Dropdown
                value={language}
                onChange={(e) => changeLanguage(e.value)}
                options={languages}
                optionLabel="name"
                placeholder={t("parameters.language.dropdown.placeholder")}
                className={styles.dropdown}
              />
            </div>
          </TabPanel>
        </TabView>
      </section>
    </div>
  );
};

export default Params;
